class QB.RatingPopover
  constructor: ()->
    _require [
      'bootstrap/popover'
    ], ->
      newPopoverTemplate = $($.fn.popover.Constructor.DEFAULTS.template).removeClass('grey-popover')

      $(".js-rating").popover
        html: true,
        container: 'body',
        trigger: 'hover',
        content: -> $(this).next('.js-rating-popover').html(),
        template: newPopoverTemplate.clone(),
        placement: 'bottom'

      $(".js-show-description-popover").popover
        html: true,
        container: 'body',
        trigger: 'hover',
        content: -> $(this).next('.js-description-popover').html(),
        template: newPopoverTemplate.clone(),
        placement: 'bottom'

$ ->
  new QB.RatingPopover()
